import constantsAuth from "./auth";
import cookies from "./cookies";
import constantsCustomEvents from "./customEvents";
import constantsDebts from "./debts";
import constantsLegacyAuth from "./legacyAuth";
import constantsLoans from "./loans";
import constantsRedline from "./redline";
import constantsRiachuelo from "./riachuelo";
import constantsUnlockFeatureTag from "./unlockFeatureTag";

const constants = {
	auth: constantsAuth,
	cookies: cookies,
	legacyAuth: constantsLegacyAuth,
	redline: constantsRedline,
	riachuelo: constantsRiachuelo,
	debts: constantsDebts,
	loans: constantsLoans,
	customEvents: constantsCustomEvents,
	unlockFeatureTag: constantsUnlockFeatureTag,
};

export default constants;
